<p-dialog
  #dialog
  *ngIf="visible"
  [style]="{ width: '95vw' }"
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [maximizable]="true"
  [resizable]="false"
  (onShow)="dialog.maximize()"
  (onHide)="onClose()"
  (visibleChange)="onChangeVisible($event)"
>
  <ng-template pTemplate="header">
    <div class="header">Выбор шаблона</div>
  </ng-template>

  <div class="content">
    <app-reports-templates-table
      [selectedItem]="selectedItem"
      (onSelectionChanged)="selectionChange($event)"
    ></app-reports-templates-table>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'Выбрать'" (click)="onAccept()"></button>

    <button pButton type="button" [outlined]="true" [label]="'Отмена'" (click)="onClose()"></button>
  </ng-template>
</p-dialog>
